import { Divider, Paper, Stack, Typography } from '@mui/material';
import type { ChartsAxisContentProps } from '@mui/x-charts/ChartsTooltip';
import { DEFAULT_CURRENCY, MONTHS } from '@weft/types';
import { dayjs, isNullOrUndefined } from '@weft/utils';
import { ColorDot } from 'apps/app/src/components/design/ColorDot';
import { Price } from 'apps/app/src/components/design/Price';

export const RevenueBarChartToolTip: React.FC<ChartsAxisContentProps> = ({ dataIndex, series }) => {
  if (isNullOrUndefined(dataIndex) || dataIndex > 11) {
    return null;
  }

  const [fixedBarSeries, usageBarSeries, lineSeries] = series;
  const usageBarValue = usageBarSeries.data[dataIndex];
  const fixedBarValue = fixedBarSeries.data[dataIndex];
  const lineValue = lineSeries.data[dataIndex];
  
  const year = dayjs().year();
  const monthLabel = MONTHS[dataIndex];

  const formattedUsageBarValue = typeof usageBarValue === 'number' ? usageBarValue : '--';
  const formattedFixedBarValue = typeof fixedBarValue === 'number' ? fixedBarValue : '--';
  const formattedLineValue = typeof lineValue === 'number' ? lineValue : '--';

  return (
    <Paper sx={{
      backgroundColor: '#0D1B27DE',
      transform: 'translate(-50%, -120%)',
      width: '300px',
    }}
    >
      <Stack
        direction="column"
        alignItems="start"
        gap={1}
      >
        <Typography
          fontSize="15px"
          lineHeight="18px"
          fontWeight={500}
          textAlign="center"
          color="white"
          paddingTop={1}
          paddingX={1}
        >
          {`${monthLabel}, ${year}`}
        </Typography>
        <Divider
          color='#37474F'
          sx={{ width: '100%' }}
        />
        <Stack
          paddingBottom={1}
          paddingX={1}
          direction="row"
          alignItems="center"
          width="100%"
          gap={0.5}
        >
          <ColorDot
            sizeOverride='9px'
            color="#ECEDEE"
          />
          <Price
            fontSize="14px"
            lineHeight="18px"
            fontWeight={500}
            textAlign="center"
            color="white"
            rounded
            currency={DEFAULT_CURRENCY}
          >
            {formattedUsageBarValue}
          </Price>
          <Typography
            fontSize="14px"
            lineHeight="18px"
            fontWeight={500}
            textAlign="center"
            color="#90A4AE"
            paddingLeft={1}
            marginLeft="auto"
          >
            Variable Revenue
          </Typography>
        </Stack>
        <Stack
          paddingBottom={1}
          paddingX={1}
          direction="row"
          alignItems="center"
          width="100%"
          gap={0.5}
        >
          <ColorDot
            sizeOverride='9px'
            color="#8c8d8f"
          />
          <Price
            fontSize="14px"
            lineHeight="18px"
            fontWeight={500}
            textAlign="center"
            color="white"
            rounded
            currency={DEFAULT_CURRENCY}
          >
            {formattedFixedBarValue}
          </Price>
          <Typography
            fontSize="14px"
            lineHeight="18px"
            fontWeight={500}
            textAlign="center"
            color="#90A4AE"
            paddingLeft={1}
            marginLeft="auto"
          >
            Fixed Revenue
          </Typography>
        </Stack>
        <Stack
          paddingBottom={1}
          paddingX={1}
          direction="row"
          alignItems="center"
          width="100%"
          gap={0.5}
        >
          <ColorDot
            sizeOverride='9px'
            color="#C250FF"
          />
          <Price
            fontSize="14px"
            lineHeight="18px"
            fontWeight={500}
            textAlign="center"
            color="white"
            rounded
            currency={DEFAULT_CURRENCY}
          >
            {formattedLineValue}
          </Price>
          <Typography
            fontSize="14px"
            lineHeight="18px"
            fontWeight={500}
            textAlign="center"
            color="#90A4AE"
            paddingLeft={1}
            marginLeft="auto"
          >
            Forecast
          </Typography>
        </Stack>
      </Stack>            
    </Paper>
  );
};